<ejs-grid #grid
          class="grid-with-toolbar"
          width="100%"
          rowHeight="38"
          [dataSource]="tags"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)">
  <ng-template #toolbarTemplate
               let-data>
    <ejs-toolbar>
      <e-items>
        <e-item text="{{ 'i18n.domain.parker-administration.add-tag' |  translate }}"
                prefixIcon="e-icons icon-add"
                (click)="onAdd()"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column field="id"
              [visible]="false"
              headerText="id"
              [isPrimaryKey]="true"></e-column>
    <e-column field="identificationCode"
              headerText="{{'i18n.domain.parker-administration.form.identificationCode' | translate}}"
              clipMode="EllipsisWithTooltip"></e-column>
    <e-column field="barcode"
              headerText="{{'i18n.domain.parker-administration.form.barcode' | translate}}"
              clipMode="EllipsisWithTooltip"></e-column>
    <e-column field="countryCode"
              headerText="{{'i18n.domain.parker-administration.form.countryCode' | translate}}"
              clipMode="EllipsisWithTooltip"></e-column>
    <e-column field="controlPlateType"
              headerText="{{'i18n.domain.parker-administration.form.controlPlateType' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #filterItemTemplate let-data>{{formatControlPlateType(data) | translate}}</ng-template>
      <ng-template #template let-data>
        {{formatControlPlateType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column field="operationalControlPlate"
              headerText="{{'i18n.domain.parker-administration.form.controlPlateNumber' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{data.operationalControlPlate}}</span>
      </ng-template>
    </e-column>
    <e-column field="description"
              headerText="{{'i18n.domain.parker-administration.form.description' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span>{{data.description | translate}}</span>
      </ng-template>
    </e-column>
    <e-column field="active"
              width="70px"
              headerText="{{'i18n.shared.fields.active' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template
                   let-data>
              <span class="e-icons"
                    [class.icon-checkmark]="data.active"></span>
      </ng-template>
    </e-column>
    <e-column field="defect"
              width="70px"
              headerText="{{'i18n.domain.parker-administration.form.defect' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template
                   let-data>
              <span class="e-icons"
                    [class.icon-checkmark]="data.defect"></span>
      </ng-template>
    </e-column>
    <e-column headerText=""
              [commands]="commands"
              width="120px"></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate
               let-data>
    <app-edit-parker-edit-tag-list-form [parkerTagForm]="gridEditForm" [allTags]="tags"></app-edit-parker-edit-tag-list-form>
  </ng-template>
</ejs-grid>
